import { graphql } from '@/gql';

export const UpdateTrainersNotesResultMutation = graphql(`
    mutation UpdateTrainersNotesResult($id: ObjectID!, $input: UpdateTrainersNotesResultInput!) {
        updateTrainersNotesResult(id: $id, input: $input) {
            __typename
            ... on UpdateTrainersNotesResultSuccessfulResponse {
                result {
                    id
                    result {
                        ... on TrainersNotesResult {
                            trainersNotes
                            status
                        }
                    }
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

export const SubmitTrainersNotesResultMutation = graphql(`
    mutation SubmitTrainersNotesResult($input: SubmitTrainersNotesResultInput!) {
        submitTrainersNotesResult(input: $input) {
            __typename
            ... on SubmitTrainersNotesResultSuccessfulResponse {
                result {
                    id
                    result {
                        ... on TrainersNotesResult {
                            trainersNotes
                            status
                        }
                    }
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

export const GenerateTrainersNotesMutation = graphql(`
    mutation GenerateTrainersNotes($input: GenerateTrainersNotesInput!) {
        generateTrainersNotes(input: $input) {
            __typename
            ... on GenerateTrainersNotesQueuedResponse {
                queued
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

export const TrainersNotesGenerationUpdatesSubscription = graphql(`
    subscription TrainersNotesGenerationUpdates(
        $token: String!
        $assessmentRunId: ObjectID!
        $traineeUserId: ObjectID!
    ) {
        eventFromTrainersNotesGeneration(
            token: $token
            assessmentRunId: $assessmentRunId
            traineeUserId: $traineeUserId
        ) {
            suggestion
            state
            error
        }
    }
`);
